import {StarIcon} from '@primer/octicons-react'

import {Link} from '@primer/react'

import type {McpDetails} from '../../../../types'

import {InstallButton} from '../../../../components/InstallButton/InstallButton'

import styles from './About.module.css'

type Props = {
  mcp: McpDetails
}

export function About({mcp}: Props) {
  const owner = mcp.name_with_owner ? mcp.name_with_owner.split('/')[0] : null

  return (
    <div className={styles.about}>
      {mcp.owner_avatar_url ? (
        <div className={styles.logoContainer}>
          <img src={mcp.owner_avatar_url} alt={`${mcp.display_name} logo`} className={styles.logo} />
        </div>
      ) : null}

      <p className={styles.heading}>{mcp.display_name}</p>

      <p className={styles.subheading}>
        {owner ? (
          <span>
            By{' '}
            <Link href={`https://github.com/${owner}`} inline className={styles.ownerLink}>
              {owner}
            </Link>
          </span>
        ) : null}

        {mcp.stargazer_count ? (
          <>
            <span>·</span>
            <span className={styles.group}>
              <StarIcon size={16} />
              {mcp.stargazer_count.toLocaleString()}
            </span>
          </>
        ) : null}
      </p>

      <p className={styles.description}>{mcp.description}</p>

      <InstallButton mcp={mcp} />
    </div>
  )
}
